import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhonemin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m23.983 6.527-2.912-2.91a1.881 1.881 0 0 0-2.669 0l-3.136 3.131a1.887 1.887 0 0 0 0 2.675l2.45 2.452a11.084 11.084 0 0 1-2.363 3.481 11.107 11.107 0 0 1-3.478 2.368l-2.45-2.453a1.88 1.88 0 0 0-2.668 0l-3.14 3.131a1.887 1.887 0 0 0 0 2.675l2.91 2.909a3.274 3.274 0 0 0 2.302.954c.178 0 .35-.013.525-.044 3.62-.596 7.214-2.523 10.115-5.422 2.898-2.904 4.823-6.497 5.425-10.12a3.26 3.26 0 0 0-.91-2.827Zm-1.028 2.502c-.533 3.224-2.267 6.44-4.878 9.05-2.611 2.612-5.824 4.346-9.048 4.879a1.286 1.286 0 0 1-1.116-.361l-2.857-2.858 3.03-3.032 3.275 3.281.025.025.59-.219a13.16 13.16 0 0 0 7.813-7.815l.218-.59-3.303-3.3 3.03-3.033 2.857 2.857c.296.296.432.711.364 1.116Z",
		fill: "#fff"
	})
});
const ForwardRef = forwardRef(SvgPhonemin);
export { ForwardRef as ReactComponent };
